
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useState } from 'react';
import HeaderLogo from '../shared/HeaderLogo';
import { Paper } from '@mui/material';
import useAuth from '../../hooks/useAuth'
import axios from '../../utils/axios'
import { useNavigate } from 'react-router-dom';

const HeaderBar = ({setOpen}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {logout} = useAuth();
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setOpen(value => !value);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const unAuth = async () => {
    handleClose();
    logout();
    await axios.post('token/logout');
    navigate('/login');
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* TODO: change color */}
      <AppBar position="static" color="" component={Paper}>
        <Toolbar>
          <IconButton
            className='buttonHeader'
            size="large"
            edge="start"
            color="primary"
            aria-label="menu"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
            <HeaderLogo/>
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="primary"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={unAuth}>Déconnexion</MenuItem>
              </Menu>
            </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default HeaderBar;
